module.exports = __webpack_public_path__ + "img/NThrowingAxeMan64_ua.5336765e.webp";